import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { ComponentPageTitle } from '../page-title/page-title.component';
import { FormGroup, FormBuilder, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { GatewayService } from 'src/app/gateway.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { switchMap, debounceTime, tap, finalize } from 'rxjs/operators';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { Subscription } from 'rxjs/Subscription';
import { SelectCampanaService, BusquedaService } from '../home/busqueda.service';

@Component({
  selector: 'app-supervisor',
  templateUrl: './supervisor.component.html',
  styleUrls: ['./supervisor.component.scss'],
  providers: [BusquedaService,SelectCampanaService]
})
export class SupervisorComponent implements OnInit {

  public showMenu: boolean = false;
  public newtitle: string;
  public filter: string = '';
  public rol;
  public sidenavWidth = 11;
  public isopen: boolean = false;
  public navautosize: boolean = false;

  public isLoadingCampana: boolean = false;
  public filteredOptions: Observable<string[]>;
  public campanaListSelect: any = [];
  public disabledselect: boolean;
  private subscription: Subscription;
  public supervisor={nombre:'',apellido:''};

  @ViewChild('sidenav') sidenav: any;

  grupoVal = new FormGroup({
    campana: new FormControl(''),
  });

  constructor(
    private router: Router,
    public componentPageTitle: ComponentPageTitle,
    public _next: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private gateway: GatewayService,
    private localSave: LocalSaveService,
    private _selectCampana: SelectCampanaService,
    public _busqueda: BusquedaService,
  ) {

    this.router.events.subscribe((val:NavigationEnd) => {
      let auxurl = val.url;
      if(auxurl){
        if(auxurl.includes('/supervisor/dashboardpivot')){
          this.disabledselect = true;
          //this.disabledsearch = true;
          
        }
        else{
          this.disabledselect = false;
         // this.disabledsearch = false;
        }
      }
    });

   }

  ngOnInit() {
    this.supervisor = this.localSave.get('usuarioPGV');
    this.loadCampana();
    this.subscription = this._busqueda.notifyObservableClean$.subscribe(
      res => {
        this.filter = '';
      });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public open() {
    if (this.isopen) {
      this.isopen = false;
      this.decrease();
    } else {
      this.navautosize = true;
      this.isopen = true;
      this.increase();
    }
  }

  public increase() {
    if (this.isopen) {
    } else {
      this.navautosize = false;
    }
    this.sidenavWidth = 19;
  }

  public decrease() {
    if (!this.isopen) {
      this.sidenavWidth = 11;
    }
  }

  public toggleMenu() {
    this.showMenu = !this.showMenu;
  }

  public getTitle() {
    return this.componentPageTitle.title;
  }

  public keyDownFunction(event) {
    if (event.keyCode === 13) {
      this.filtrogeneral();
    } else if (event.keyCode === 8 && this.filter === '') {
      this.filtrogeneral();
    }
  }

  public filtrogeneral() {
    this._busqueda.notificarBusqueda({ filtro: this.filter });
  }

  public cerrarsesion(){
    this.localSave.delete('usuarioPGV');
    this.router.navigate(['login']);
  }

  public loadCampana() {
    this.gateway.get('getcampana', { NUM_PAGINA: 0, FILTRO: null, NUM_ELEMENTOS: 99999999, IDPAIS: 5 }).then((result: any) => {
      
      const arraux = result.rows;

      arraux.sort((a, b)=>(a.nombre.toLowerCase()>b.nombre.toLowerCase()) ? 1:-1);

      this.filteredOptions = arraux;
    }
    ).catch(function (e) {
    });
  }

  public selectcampana(campana?,event?){
     this._selectCampana.notificarSCampana({ campana: this.grupoVal.controls.campana.value, julito:0 });
  }

}
